"use strict";

export class DragElement {

    constructor(element, dragZone, option) {
        this.option = option || {};
        this.elmnt = element;
        this.dragZone = dragZone;
        this.x = 0;
        this.y = 0;
        this.xoff = 0;
        this.yoff = 0;

        this._dragMouse = this.dragMouseDown.bind(this);
        this._closeDrag = this.closeDragElement.bind(this);
        this._elementDrag = this.elementDrag.bind(this);
        this.dragTouchStart = this.dragTouchStart.bind(this);
        this.dragTouchMove = this.dragTouchMove.bind(this);
        this.dragTouchEnd = this.dragTouchEnd.bind(this);

        this.addDragEvent(dragZone);
    }

    addDragEvent(dragZone) {
        if (dragZone) {
            if (
                ('ontouchstart' in window) ||
                (navigator.maxTouchPoints > 0) ||
                (navigator.msMaxTouchPoints > 0)
            ) {
                dragZone.addEventListener('touchstart', this.dragTouchStart, false);
            }
            dragZone.addEventListener('mousedown', this._dragMouse, false);
        }
    }

    setDragZone(dragZone) {
        if (dragZone) {
            this.dispose();
            this.addDragEvent(dragZone);
            this.dragZone = dragZone;
        }
    }

    dragMouseDown(e) {
        e = e || window.event;

        this.xoff = e.clientX - this.elmnt.offsetLeft;
        this.yoff = e.clientY - this.elmnt.offsetTop;

        document.addEventListener('mouseup', this._closeDrag, false);
        document.addEventListener('mousemove', this._elementDrag, false);
    }

    dragTouchStart(e) {
        e = e || window.event;
        if (!e.cancelable) return;
        if (e.composedPath()[0] !== this.dragZone) return;
        e.preventDefault();

        this.xoff = e.changedTouches[0].clientX - this.elmnt.offsetLeft;
        this.yoff = e.changedTouches[0].clientY - this.elmnt.offsetTop;

        document.addEventListener('touchend', this.dragTouchEnd, false);
        document.addEventListener('touchmove', this.dragTouchMove, false);
    }

    dragTouchMove(e) {
        this.x = e.changedTouches[0].clientX - this.xoff;
        this.y = e.changedTouches[0].clientY - this.yoff;

        if (this.option.controlPosition) {
            const elmnt = this.elmnt.getBoundingClientRect();

            if (window.innerWidth < this.x + elmnt.width) this.x = window.innerWidth - elmnt.width - 2;
            if (this.x < 0) this.x = 0;
            if (window.innerHeight < this.y + elmnt.height) this.y = window.innerHeight - elmnt.height - 2;
            if (this.y < 0) this.y = 0;
        } else {
            if (e.clientX < 0) this.x = - this.xoff;
            if (e.clientY < 0) this.y = - this.yoff;
            if (window.innerWidth < e.clientX) this.x = window.innerWidth - this.xoff;
            if (window.innerHeight < e.clientY) this.y = window.innerHeight - this.yoff;
        }

        this.elmnt.style.top = `${this.y}px`;
        this.elmnt.style.left = `${this.x}px`;
    }

    dragTouchEnd() {
        document.removeEventListener('touchend', this.dragTouchEnd, false);
        document.removeEventListener('touchmove', this.dragTouchMove, false);
    }

    elementDrag(e) {
        e = e || window.event;

        this.x = e.clientX - this.xoff;
        this.y = e.clientY - this.yoff;

        if (this.option.controlPosition) {
            const elmnt = this.elmnt.getBoundingClientRect();

            if (window.innerWidth < this.x + elmnt.width) this.x = window.innerWidth - elmnt.width - 2;
            if (this.x < 0) this.x = 0;
            if (window.innerHeight < this.y + elmnt.height) this.y = window.innerHeight - elmnt.height - 2;
            if (this.y < 0) this.y = 0;
        } else {
            if (e.clientX < 0) this.x = - this.xoff;
            if (e.clientY < 0) this.y = - this.yoff;
            if (window.innerWidth < e.clientX) this.x = window.innerWidth - this.xoff;
            if (window.innerHeight < e.clientY) this.y = window.innerHeight - this.yoff;
        }

        this.elmnt.style.top = `${this.y}px`;
        this.elmnt.style.left = `${this.x}px`;
    }

    closeDragElement() {
        document.removeEventListener('mouseup', this._closeDrag, false);
        document.removeEventListener('mousemove', this._elementDrag, false);
    }

    dispose() {
        if (
            ('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0)
        ) {
            this.dragZone.removeEventListener('touchstart', this.dragTouchStart, false);
        }
        this.dragZone.removeEventListener('mousedown', this._dragMouse, false);
    }
}
